import resources from '../resource.js';

const resource = 'applicationFields';

export default {
    index(step, forms) {
        return resources.get(`${resource}?step=${step}&forms=${forms}`);
    },
}
